import { Component } from '@angular/core';

@Component({
  selector: 'app-coupons-main',
  templateUrl: './coupons-main.component.html',
  styleUrls: ['./coupons-main.component.css']
})
export class CouponsMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {
  
      this.english = false;
      this.hindi = true;
    }
  
  }
}
